import { usePartnerDetails } from '@/hooks/usePartnerDetails';
import { usePartnerSubAccountCreation } from '@/hooks/usePartnerSubAccountCreation';
import { Button } from '../../ui/button';
import { Plus } from 'lucide-react';

export const NoAccounts = ( {searchQuery }: {searchQuery: string}) => {
  const { data: partnerDetails } = usePartnerDetails();
  const { canCreateSubAccounts, hasCustomSubscriptionPlans, hasCustomBoostPackPricing } = usePartnerSubAccountCreation();
  const isWhiteLabelPartner = partnerDetails?.partner_type === 'white_label';

  const title = searchQuery ? 'No matching sub-accounts found' : 'No sub-accounts yet';

  const line1 = searchQuery
    ? `No sub-accounts match your search for "${searchQuery}"`
    : 'Sub-accounts are your own customers';

  const line2 = searchQuery
    ? 'Try adjusting your search terms or browse all sub-accounts'
    : (isWhiteLabelPartner
        ? 'You can set custom plans and pricing for each account'
        : 'Share subscription links to onboard your clients');

  // Determine if setup is required
  const setupRequired = isWhiteLabelPartner && !canCreateSubAccounts;
  const missingSetup = [];
  if (isWhiteLabelPartner && !hasCustomSubscriptionPlans) {
    missingSetup.push('custom subscription plans');
  }
  if (isWhiteLabelPartner && !hasCustomBoostPackPricing) {
    missingSetup.push('custom boost pack pricing');
  }

  return (
    <div className="flex w-full flex-col items-center justify-center py-10">
      <h3 className="text-2xl font-semibold text-foreground mb-2">{title}</h3>
      <p className="text-foreground-muted text-center text-sm mb-6">
        {line1} <br/>
        {line2}
      </p>
      

      {setupRequired && (
        <Button 
          disabled={true}
          className="opacity-50 cursor-not-allowed"
        >
          <Plus className="size-4 mr-2" />
          Create New Sub-Account
        </Button>
      )}
      
      {setupRequired && (
        <p className="text-xs text-muted-foreground mt-2 text-center">
          Complete the steps above to enable sub-account creation
        </p>
      )}
    </div>
  )
}